import CookieAuthPlugin from "./CookieAuthPlugin";

const plugins = [CookieAuthPlugin];

export default function Plugins({ children }) {
  return plugins.reduce((acc, Provider) => {
    return <Provider>{acc}</Provider>;
  }, children);
}
